import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import GameHero from '../components/GameHero';
import GameMedia from '../components/GameMedia';
import JoinUsSection from '../components/JoinUsSection';
import { getGameBySlug } from '../data/games';

function GamePage() {
  const { slug } = useParams<{ slug: string }>();
  const game = slug ? getGameBySlug(slug) : undefined;

  useEffect(() => {
    if (game) {
      document.title = `${game.title} | Kaddera Games`;
    }
    return () => {
      document.title = 'Kaddera Games';
    };
  }, [game]);

  if (!game) {
    return <Navigate to="/" replace />;
  }

  const platformLabel = game.platform === 'steam' ? 'Steam' : 'itch.io';

  const handleWatchTrailer = () => {
    if (game.trailerUrl) {
      window.open(game.trailerUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    const trailer = document.getElementById('game-trailer') as HTMLVideoElement | null;
    if (!trailer) {
      return;
    }

    trailer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    trailer.muted = false;
    trailer.currentTime = 0;
    trailer.play().catch(() => {
      trailer.muted = true;
      trailer.play().catch(() => undefined);
    });
  };

  return (
    <main className="kg-main kg-game-page">
      <GameHero game={game} />

      <section className="kg-game-actions">
        <div className="kg-game-actions-inner">
          <div className="kg-game-actions-buttons">
            <a
              href={game.storeLink}
              className="kg-btn kg-btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              {game.ctaLabel}
            </a>
            {game.trailerUrl || game.heroVideo ? (
              <button type="button" className="kg-btn kg-btn-secondary" onClick={handleWatchTrailer}>
                Watch Trailer
              </button>
            ) : null}
          </div>
          <div className="kg-game-platform">
            <span className="kg-game-platform-label">Available on</span>
            <span className="kg-game-platform-name">{platformLabel}</span>
          </div>
        </div>
      </section>

      <section className="kg-section kg-game-about">
        <div className="kg-game-about-inner">
          <h2 className="kg-game-section-title">About</h2>
          <h3 className="kg-game-subtitle">The Game</h3>
          <p className="kg-game-about-text">{game.about}</p>
          <p className="kg-game-about-text">{game.description}</p>
        </div>
      </section>

      <GameMedia game={game} />

      <JoinUsSection />
    </main>
  );
}

export default GamePage;
